import {
  DataGrid,
  GridColDef,
  GridRowParams,
  GridSelectionModel,
} from '@mui/x-data-grid';
import { useFindAllUsersQuery } from '../../api/api-hooks';
import { UserNoPassword } from '../../api/api-types';
import { Item } from '../../utils/sharedTypes';
import { UserFilter } from './userTypes';
import { filterUserItem } from './userUtils';

interface Props {
  setSelectedUsers: React.Dispatch<React.SetStateAction<Item[]>>;
  filters: UserFilter;
  setEditModalOpenFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const UsersTable = ({
  setSelectedUsers,
  filters,
  setEditModalOpenFlag,
}: Props) => {
  const { data: users } = useFindAllUsersQuery({});
  if (users === undefined) return null;
  const columns: GridColDef[] = [
    { field: 'id', hide: true },
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'phone', headerName: 'Phone #', width: 150 },
    { field: 'address', headerName: 'Address', width: 200 },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'company', headerName: 'Company', width: 150 },
    { field: 'role', headerName: 'Role', width: 150 },
  ];
  const rows = users
    .filter((item: UserNoPassword) => filterUserItem(item, filters))
    .map((item: UserNoPassword) => ({
      ...item,
      role: item.role === 1 ? 'Admin' : 'User',
      company: item.company.companyName,
    }));
  const handleRowClick = (params: GridRowParams) => {
    setSelectedUsers(
      users.filter((user: UserNoPassword) => user.id === params.row.id)
    );
    setEditModalOpenFlag(true);
  };
  const handleTableSelection = (model: GridSelectionModel) => {
    setSelectedUsers(users.filter((user) => model.includes(user.id)));
  };
  return (
    <div style={{ paddingBottom: '1rem', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={100}
        checkboxSelection
        disableSelectionOnClick
        autoHeight
        disableColumnMenu={true}
        onSelectionModelChange={handleTableSelection}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default UsersTable;
